<template>
	<div class="rb-video-ribbon px-5 py-3">
		Próximo vídeo em {{ secondsLeft.pad(2) }}s
	</div>
</template>

<script>
	export default {
		name: 'RbNextVideoRibbon',
		props: {
			duration: {
				type: Number,
				default: 7
			}
		},
		data: () => ({
			secondsLeft: 0,
			intervalId: null
		}),
		mounted() {
			this.secondsLeft = this.duration;
			if (this.intervalId) clearInterval(this.intervalId);

			this.intervalId = setInterval(() => this.tick(), 1000);
		},
		methods: {
			tick() {
				this.secondsLeft -= 1;

				if (this.secondsLeft === 0) {
					clearInterval(this.intervalId);
					this.$emit('end');
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-video-ribbon {
		position: absolute;
		right: -2px;
		bottom: 100px;

		width: auto;
		line-height: 100%;

		border: 1px solid rgba($white, .7);
		border-radius: 5px 0 0 5px;

		cursor: default;
		user-select: none;
		transition: all .3s;

		opacity: .7;
		&:hover {
			opacity: 1;
		}
	}
</style>
